/**
 * 回复问题
 */
import React, {useState, useRef, useEffect} from 'react';
import {Form, Button, Select, Row, Col, message, Input, DatePicker, Spin, ConfigProvider} from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import {SFuncModal} from "shj-components";
import {iiHOC} from "@/utils/auth.ts";
import dayjs from "dayjs";
import {ticketsIssueReplay} from "@/services/customerServices.ts";
import {getEnums} from "@/services/homeService.ts";

const {Option} = Select;
const {TextArea} = Input;

export const ModalAddCallBackIssueTab = (props: any) => <AddCallBackIssueDom {...props} />;

export function addCallBackIssueFn(val: any) {
  const onClose = () => {
    dialog.destroy();
  };

  const dialog = SFuncModal({
    title: `回复问题`,
    width: 700,
    vanish: true,
    content: (
        <>
          <ConfigProvider locale={zhCN}>
            <AddCallBackIssueDom onClose={onClose} {...val} />
          </ConfigProvider>
        </>
    ),
  });
  return dialog;
}

const AddCallBackIssueDom = (params: any) => {
  const {onClose, fn, id, issueId, formOnly} = params;
  const formNode = useRef<any>();
  const [form] = Form.useForm();
  const {setFieldsValue} = form;
  const [loading, setLoading] = useState(false);
  const [isSpecial, setIsSpecial] = useState(false);
  const [spinLoading, setSpinLoading] = useState(false);
  const [issueReplyStatusEnum, setIssueReplyStatusEnum] = useState([]);

  useEffect(() => {
    getOptions()
  }, []);

  const getOptions = async () => {
    const issueReplyStatusEnum = await getEnums('plus-crm', 'com.shj.saas.plus.crm.domain.tickets.enums.IssueReplyStatusEnum')
    setIssueReplyStatusEnum(issueReplyStatusEnum)
  }

  const btnStatus = (otherStatus: boolean) => {
    if (isSpecial) {
      return false;
    }
    return otherStatus;
  };

  const onFinish = () => {
    if (loading) return;
    form.validateFields().then(values => {
      setLoading(true);
      let _parameters = {
        ...values,
        disposeDate: values?.disposeDate
            ? dayjs(values['disposeDate']).format('YYYY-MM-DD HH:mm:ss')
            : '',
        id: issueId, //问题ID
      };
      ticketsIssueReplay(_parameters).then((resp: any) => {
        message.success(resp.message || '操作成功');
        fn && fn();
        onClose();
      })
          .finally(() => {
            setLoading(false);
          });
    })
  };
  return iiHOC(
      <div>
        <SFuncModal.Content
            onCancel={onClose}
            onOk={onFinish}
            confirmLoading={loading}
        >
        <Spin spinning={spinLoading} tip="加载中...">
          <Form
              ref={formNode}
              form={form}
              {...{
                labelCol: {
                  xs: {span: 10},
                  sm: {span: 8},
                },
                wrapperCol: {
                  xs: {span: 14},
                  sm: {span: 20},
                },
              }}
              layout='vertical'
              style={{ width: '100%' }}
          >
            <Row gutter={2}>
              <Col span={24}>
                <Form.Item label="处理结果" name="disposeStatus" required rules={[{required: true, message: '请选择'}]}>
                  <Select disabled={btnStatus(false)} placeholder="请选择" allowClear
                    options={issueReplyStatusEnum}
                          fieldNames={{label: 'description', value: 'key'}}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                    label="处理完成时间"
                    name="disposeDate"
                    required
                    rules={[{required: true, message: '请选择'}]}
                >
                  <DatePicker
                      disabled={btnStatus(false)}
                      style={{width: '100%'}}
                      allowClear
                      showTime={{
                        defaultValue: dayjs('00:00:00', 'HH:mm:ss'),
                      }}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="处理结果描述" name="disposeResult">
                  <TextArea disabled={btnStatus(false)} placeholder="请输入" style={{width: '100%'}}/>
                </Form.Item>
              </Col>

              {/*<Col span={24} style={{ textAlign: 'right' }}>*/}
              {/*  {!formOnly && (*/}
              {/*    <Button onClick={onClose} style={{ margin: '0 8px' }} loading={loading}>*/}
              {/*      取消*/}
              {/*    </Button>*/}
              {/*  )}*/}
              {/*  <Button type="primary" htmlType="submit" style={{ margin: '0 8px' }} loading={loading}>*/}
              {/*    确定*/}
              {/*  </Button>*/}
              {/*</Col>*/}
            </Row>
          </Form>
        </Spin>
        </SFuncModal.Content>
      </div>,
  );
};
